import { ATS_API_URL, typesofUsers } from "../config";
import { openPanel } from "../openpanel";
import { completeLogin } from "./completeLogin";
export interface identity {
    tokendata: string;
    refreshtoken: string;
    userid: string;
    userrole: string;
    subscriberid?: null;
    url?: null;
    trn_id?: null;
    messages: string;
}
const authProvider = {
    login: async (data) => {
        const request = new Request(ATS_API_URL + '/account/Login', {
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify({ ...data, currentTimestamp: new Date() }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        try {
            const response = await fetch(request);

            const auth = await response.json();
            if (response.status === 429) {
                alert("Too many login attempts from this IP, please try again after 10 min.")
                throw new Error("Too many login attempts from this IP, please try again after after 10 min.");
            }
            if (response.status < 200 || response.status >= 400) {
                throw new Error(auth.message);
            }

            if (response.status == 301) {
                return { redirectTo: false, ...auth };
            }

            localStorage.removeItem('RaStore.switchSubscriber');
            localStorage.removeItem('RaStore.switchSubscriberName');
            return completeLogin(auth);
        } catch (error: any) {
            throw new Error(error.message);
        }
    },
    logout: () => {
        openPanel.clear();
        localStorage.removeItem('auth');
        localStorage.removeItem('RaStore.switchSubscriber');
        localStorage.removeItem('RaStore.switchSubscriberName');
        localStorage.removeItem('orginalUserRole');
        localStorage.removeItem('userRole');
        localStorage.removeItem('TermAndConditionVefificationStatus');
        return Promise.resolve();
    },
    checkAuth: () => {
        const auth: any = localStorage.getItem('auth');
        const data = !!auth ? JSON.parse(auth) : '';
        const isThirdPartyAgent = data?.data?.userrole == typesofUsers.landlordThirdPartyAgent;
        if (isThirdPartyAgent) return Promise.reject();
        return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject()
    },
    checkError: (error) => {
        if (error) {
            const status = error.status;
            if (status === 401 || status === 403) {
                openPanel.clear();
                localStorage.removeItem('auth');
                return Promise.reject();
            }
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    getIdentity: <identity>() => {
        const { data } = JSON.parse(<any>localStorage.getItem('auth'))
        return Promise.resolve({ id: data.userid, fullName: data.fullName || data.userrole, avatar: data.avatar || "https://ui-avatars.com/api/?color=000&name=" + (data.fullName || data.userrole), ...data })
    },
    getPermissions: () => {
        const { data } = JSON.parse(<any>localStorage.getItem('auth'))

        return Promise.resolve(data?.permissions)
    },
};
export default authProvider;
